<template>
  <v-fab-transition>
    <v-btn
      fab
      x-large
      fixed
      bottom
      right
      text
      href="https://api.whatsapp.com/send?phone=60173797632"
      target="_blank"
    >
      <v-img src="@/assets/images/whatsapplogo.png" width="64px"></v-img>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {};
</script>